import './About.scss'
import { useContext } from 'react'
import { ThemeContext } from '../../context'


export default function About()
{
    const {theme} = useContext(ThemeContext)

    return(
        <main className={`about , about_${theme}`}>
            <h1>A propos</h1>
            <p>
                Soyez les bienvenus sur mon site consacré aux sciences naturelles.
            </p>

            <p>
                Je suis Amaury, passionné depuis toujours de sciences.<br/>
                Depuis ma plus jeune enfance j'ai eu la chance d'être instruit par mon père en paléontologie. Ce fut l'occasion à de nombreuses reprises d'aller chercher des fossiles lors de journées reservées à cela.<br/>
                Le plaisir de la trouvaille enchainait alors avec la curiosité de l'identification et de la connaissance.<br/>
                
            </p>

            <p>
                Ce site contient une partie de ma collection.<br/>
                J'ai souhaité à travers celui-ci vous faire découvrir et partager ma passion pour l'histoire de la vie.<br/>
                C'est ainsi que vous pourrez y trouver de nombreux spécimens fossiles mais aussi des animaux actuels.
            </p>

            <p>
                La paléontologie est une science en danger dans notre pays.<br/>
                En effet depuis quelques années, les interdictions s'enchainent sur divers sites sans aucune justification et surtout sans aucune utilité.<br/>
                Les projets de reserves absurdes comme sur les côtes du calvados où l'interdiction de collecter des fossiles même détachés naturellement de la falaise est projetée, ne fait que condamner à la destruction ceux-ci.
            </p>

            <p>
                Devant le mépris des personnes responsables de ces projets imbéciles et de ces interdictions déjà en court, il est important de ne pas abandonner le terrain, qu'il soit réel ou virtuel comme ici avec mon site.<br/>
                En effet, la science n'est pas un domaine reservé à une élite.<br/>
                La science se doit d'être accéssible gratuitement à tous et doit pouvoir dans la limite du raisonnable être praticable par tous.
            </p>

            <p>
                J'espère donc pour continuer de participer aux sciences diverses et particulièrement aux sciences naturelles sans être obligé de me cacher.<br/>
                J'invite toutes les personnes qui le peuvent à exprimer leur mécontentement quand aux interdictions.<br/>
                Ne vous laisser pas faire, la science et la connaissance appartiennent à tous.
            </p>
        </main>
    )
}